export default "__VITE_ASSET__gIeV09RM__"